import { render, staticRenderFns } from "./MemberBanner.vue?vue&type=template&id=24aacba5"
import script from "./MemberBanner.vue?vue&type=script&lang=js"
export * from "./MemberBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports